module.exports = __webpack_public_path__ + "static/media/foto4.9c26042b.png";